export { Text, TextWithCapsize } from './Text'
/** @deprecated */
export type { TextProps, TextWithCapsizeProps } from './Text'
